import React from 'react';
import styles from './AudioControlButton.module.scss';

type Props = {
  // クリック時
  onClick: () => void;
};

const AudioCompleteSentenceButton = React.memo<Props>((props) => (
  <div className={styles['player-botton-outer']}>
    <button
      type="button"
      onClick={props.onClick}
      className={styles['controller-view-btn']}
    >
      <figure className={styles['figure-icon']}>
        <div
          className={`${styles['svg-icon']} ${styles['mod-32']} ${styles['ic-skip-next']}`}
        />
      </figure>
    </button>
  </div>
));

export default AudioCompleteSentenceButton;
